module.exports = __webpack_public_path__ + "img/gs.e5a58207.svg";